// src/pages/OurStory.jsx
import React from "react";
import {
  FaIndustry,
  FaCogs,
  FaTools,
  FaTractor,
  FaMotorcycle,
  FaCertificate,
  FaBuilding,
  FaProjectDiagram,
  FaCheckCircle,
} from "react-icons/fa";
import { GiTank } from "react-icons/gi";
import { BsFillAwardFill } from "react-icons/bs";
import { MdPrecisionManufacturing } from "react-icons/md";

const milestones = [
  { year: 1981, title: "Started", desc: "Twin Star Industries founded for Cook Well Domestic Appliances", icon: <FaIndustry />, color: "bg-pink-500" },
  { year: 1982, title: "Defence Supplies", desc: "T-72 / VIJAYANTHA Tank / Kargil support", icon: <GiTank />, color: "bg-blue-500" },
  { year: 1983, title: "Typewriter Parts", desc: "FACIT / HALDA", icon: <MdPrecisionManufacturing />, color: "bg-green-500" },
  { year: 1986, title: "Agri & Engine Parts", desc: "Through Greaves", icon: <FaTractor />, color: "bg-purple-500" },
  { year: 1988, title: "Ranipet Enfield", desc: "Tractor, Fury, Mofa", icon: <FaMotorcycle />, color: "bg-red-500" },
  { year: 1995, title: "Enfield Bullet", desc: "Thiruvotriyur Division", icon: <FaTools />, color: "bg-yellow-500" },
  { year: 1998, title: "ISO Certified", desc: "ISO 9002 Certification", icon: <FaCertificate />, color: "bg-teal-500" },
  { year: 2000, title: "Machine Shop", desc: "Upgraded facilities", icon: <FaBuilding />, color: "bg-orange-500" },
  { year: 2007, title: "CNC Division", desc: "New CNC Division", icon: <FaCogs />, color: "bg-indigo-500" },
  { year: 2010, title: "Expansion", desc: "New Facility", icon: <FaBuilding />, color: "bg-lime-500" },
  { year: 2015, title: "Growth", desc: "From Lakhs to Crores", icon: <FaProjectDiagram />, color: "bg-rose-500" },
  { year: 2019, title: "Certifications", desc: "IATF & MACE", icon: <BsFillAwardFill />, color: "bg-cyan-500" },
  { year: 2025, title: "Site Extension", desc: "Unit 2 added", icon: <FaCheckCircle />, color: "bg-fuchsia-500" },
];

const OurStory = () => {
  return (
    <section className="bg-yellow-200 py-20 px-4 md:px-12 lg:px-20">
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900">
            Our Journey
          </h2>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
            A colorful timeline of milestones that shaped Twin Star Industries.
          </p>
        </div>

        {/* Timeline wrapper */}
        <div className="relative">
          {/* Central line for md+ and left line for mobile */}
          <div className="absolute top-0 h-full w-1 bg-gray-300 left-6 md:left-1/2 transform md:-translate-x-1/2"></div>

          {/* Milestones */}
          <div className="flex flex-col space-y-16">
            {milestones.map((m, i) => (
              <div
                key={i}
                className={`relative flex w-full ${
                  i % 2 === 0 ? "md:justify-start" : "md:justify-end"
                }`}
              >
                {/* Circle icon */}
                <div
                  className={`flex items-center justify-center rounded-full text-white shadow-lg text-lg
                    w-12 h-12
                    ${m.color}
                    absolute md:left-1/2 md:-translate-x-1/2
                    left-0 top-0
                    transform
                    -translate-y-1/2
                  `}
                  style={{ marginTop: "2rem" }} // spacing between icons
                >
                  {m.icon}
                </div>

                {/* Card */}
                <div
                  className={`bg-white rounded-xl shadow-lg p-6 sm:p-8 flex flex-col justify-center
                    w-full md:w-[500px]
                    ${i % 2 === 0 ? "md:mr-auto md:text-right md:pr-8" : "md:ml-auto md:text-left md:pl-8"}
                    ml-16 md:ml-0 // add left margin on mobile to prevent overlap
                  `}
                >
                  <span className="block text-xl sm:text-2xl font-bold text-gray-800">
                    {m.year}
                  </span>
                  <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mt-2">
                    {m.title}
                  </h3>
                  <p className="mt-3 text-gray-700 text-base sm:text-lg leading-relaxed">
                    {m.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurStory;
